import clientConfig from "../config/client";
import moment from "moment";
import "moment/dist/locale/ru";

export const monthNames = moment.locale(clientConfig.locale) && moment.months();
export const weekDays =
    moment.locale(clientConfig.locale) && moment.weekdaysShort(true);

export const sortableFields = [
    "id",
    "type",
    "name",
    "active",
    "key",
    "value",
    "order",
    "created_at",
    "date_in",
    "date_out",
    "total",
    "status",
    "number",
    "order_number",
    "guestName",
    "roomName",
    "promo_code",
    "using_start_date",
    "using_end_date",
    "start_date",
    "end_date",
    "email",
    "name",
    "room_type_id",
    "rate",
    "name_guest",
    "order_source",
    "entity_id",
    "interface_id",
    "updated_at",
    "user_id",
    "message_type",
    "status_pms",
    "purchased_status",
    "reservation_number",
    "category_services",
    "reservation_id"
];

export const namesForIndicator = [
    "active",
    "card_guarantee",
    "payment_required",
    "scope_individual",
    "scope_partners",
    "scope_channel",
];

export const FIRST_PAGE = "first_page";
export const PREV_PAGE = "previous_page";
export const NEXT_PAGE = "next_page";
export const LAST_PAGE = "last_page";

export const ASC = "asc";
export const DESC = "desc";

export const SEARCH_FIELDS_FOR_STRING = [
    "name",
    "login",
    "first_name",
    "last_name",
    "email",
    "type",
];

export const SEARCH_FIELDS = {
    hotels: { name: "" },
    rates: {
        name: "",
        active: "1",
        hidden: "",
        inherited: "",
        date_start: "",
        date_end: "",
    },
    reservations: {
        page: "1",
        sortField: "id",
        sortOrder: DESC,
        created_at: "",
        number: "",
        order_number: "",
        promo_code: "",
        guest: "",
        date_in: "",
        date_out: "",
        status_pms: "",
        room_type_id: "",
        rate: "",
        status: "",
        total: "",
        order_source: "",
    },
    subscriptions: {
        page: "1",
        sortField: "id",
        sortOrder: DESC,
        created_at: "",
        date_in: "",
        date_out: "",
        room_type_id: "",
        promo_code: "",
        status: "",
        name: "",
        email: "",
    },
    promo: {
        name: "",
        created_at: "",
        start_date: "",
        end_date: "",
        using_start_date: "",
        using_end_date: "",
        active: "",
    },
    users: {
        login: "",
        type: "",
        email: "",
        hotels: "",
        first_name: "",
        last_name: "",
    },
    operators: {
        login: "",
        active: "",
        email: "",
        first_name: "",
        last_name: "",
    },
    services: {
        name: "",
        active: "",
    },
    reservations_new: {
        created_at: "",
        number: "",
        order_number: "",
        promo_code: "",
        guest: "",
        date_in: "",
        date_out: "",
        room_type_id: "",
        rate: "",
        status: "",
        total: "",
        page: "1",
        sortField: "id",
        sortOrder: "desc",
        order_source: "",
    },
    message_logs: {
        message_type: "",
        id: "",
        status: "",
        entity_id: "",
        interface_name: "",
        page: "1",
        sortField: "id",
        sortOrder: DESC,
    },
    purchased_services: {
        status: "",
        reservation_number: "",
        category_services: "",
        page: "1",
        sortField: "id",
        sortOrder: DESC,
    },
    refund: {
        reservation_id: "",
        order_number: "",
        total: "",
        status: "",
        created_at: "",
        guest: "",
        page: "1",
        sortField: "created_at",
        sortOrder: DESC,
    }
};

export const SEARCH_FIELDS_DEFAULT = {
    hotels: { name: "" },
    rates: {
        name: "",
        active: "1",
        hidden: "",
        inherited: "",
        date_start: "",
        date_end: "",
    },
    reservations: {
        page: "1",
        sortField: "id",
        sortOrder: DESC,
        created_at: "",
        number: "",
        order_number: "",
        promo_code: "",
        guest: "",
        date_in: "",
        date_out: "",
        status_pms: "",
        room_type_id: "",
        rate: "",
        status: "",
        total: "",
        order_source: "",
    },
    subscriptions: {
        page: "1",
        sortField: "id",
        sortOrder: DESC,
        created_at: "",
        date_in: "",
        date_out: "",
        room_type_id: "",
        promo_code: "",
        status: "",
        name: "",
        email: "",
    },
    promo: {
        name: "",
        created_at: "",
        start_date: "",
        end_date: "",
        using_start_date: "",
        using_end_date: "",
        active: "",
    },
    users: {
        login: "",
        type: "",
        email: "",
        hotels: "",
        first_name: "",
        last_name: "",
    },
    operators: {
        login: "",
        active: "",
        email: "",
        first_name: "",
        last_name: "",
    },
    services: {
        name: "",
        active: "",
    },
    reservations_new: {
        created_at: "",
        number: "",
        order_number: "",
        promo_code: "",
        guest: "",
        date_in: "",
        date_out: "",
        room_type_id: "",
        rate: "",
        status: "",
        total: "",
        page: "1",
        sortField: "id",
        sortOrder: "desc",
        order_source: "",
    },
    message_logs: {
        message_type: "",
        id: "",
        status: "",
        entity_id: "",
        interface_name: "",
        page: "1",
        sortField: "id",
        sortOrder: DESC,
    },
    purchased_services: {
        status: "",
        reservation_number: "",
        category_services: "",
        page: "1",
        sortField: "id",
        sortOrder: DESC,
    },
    refund: {
        created_at: "",
        reservation_id: "",
        order_number: "",
        status: "",
        guest: "",
        total: "",
        page: "1",
        sortField: "created_at",
        sortOrder: DESC,
    }
};

export const NAMES_FIELDS = {
    created_at: "Дата создания",
    number: "Номер бронирования",
    order_number: "Номер заказа",
    promo_code: "Промокод",
    guest: "ФИО гостя",
    date_in: "Дата заезда",
    date_out: "Дата выезда",
    room_type_id: "Категория номера",
    rate: "Тариф",
    reservation_id: "ИД заявки",
    status: "Статус",
    total: "Общая сумма",
    order_source: "Источник заказа",
    entity_id: "Ид",
};

export const STATUSES = [
    { id: "new", name: "Новое" },
    { id: "approved", name: "Подтверждено" },
    { id: "paid", name: "Оплачено" },
    { id: "cancelled", name: "Отменено" },
    { id: "closed", name: "Завершено" },
    { id: "except_cancelled", name: "Кроме отменено" },
    { id: "refund", name: "Возврат" },
];

export const STATUSES_HRS_MESSAGE_LOGS = [
    { id: "new", name: "Новое" },
    { id: "approved", name: "Подтверждено" },
    { id: "paid", name: "Оплачено" },
    { id: "cancelled", name: "Отменено" },
    { id: "closed", name: "Завершено" },
    { id: "except_cancelled", name: "Кроме отменено" },
    { id: "refund", name: "Возврат" },
];

export const STATUSES_PURCHASED_SERVICES = [
    { id: "new", name: "Не оказана" },
    { id: "complete", name: "Выполнено" },
    { id: "cancelled_guest", name: "Отменено гостем" },
    { id: "cancelled_manager", name: "Отменено менеджером" },
];

export const ORDER_SOURCE = [
    { id: "oob", name: "ООБ" },
    { id: "mobile", name: "Мобильное приложение" },
    { id: "other", name: "Сайт" },
];

export const COMPARE_VALUES = [
    { "=": "eq:", title: "равно" },
    { ">": "gt:", title: "больше" },
    { "<": "lt:", title: "меньше" },
    { "<=": "lteq:", title: "меньше или равно" },
];

export const COMPARE_STRINGS_ARR = ["eq:", "lt:", "gt:", "lteq:"];

export const ENTITIES_WITH_COMPARE = [
    "date_start",
    "date_end",
    "date_in",
    "date_out",
    "created_at",
    "total",
    "start_date",
    "end_date",
    "using_start_date",
    "using_end_date",
];

export const UNAVAILABILITY_MESSAGE = "Unavailable";

export const SEARCH_FIELD_TYPES = {
    createdAt: {
        name: "created_at",
        label: { ru: "Дата создания", en: "Created at" },
    },
    dateIn: {
        name: "date_in",
        label: { ru: "Дата заезда", en: "Date in" },
    },
    dateStart: {
        name: "date_start",
        label: { ru: "Дата начала проживания", en: "Date start" },
    },
    start_date: {
        name: "start_date",
        label: { ru: "Дата начала проживания", en: "Date start" },
    },
    end_date: {
        name: "end_date",
        label: { ru: "Дата окончания проживания", en: "Date end" },
    },
    using_start_date: {
        name: "using_start_date",
        label: { ru: "Бронирование с ..", en: "Booking  start" },
    },
    using_end_date: {
        name: "using_end_date",
        label: { ru: "Бронирование по ..", en: "Booking  end" },
    },
    dateOut: {
        name: "date_out",
        label: { ru: "Дата выезда", en: "Date out" },
    },
    dateEnd: {
        name: "date_end",
        label: { ru: "Дата окончания проживания", en: "Date end" },
    },
    total: {
        name: "total",
        label: { ru: "Общая сумма", en: "Total" },
    },
    status: {
        name: "status",
        label: { ru: "Статус", en: "Status" },
    },
    roomTypeId: {
        name: "room_type_id",
        label: { ru: "Категория", en: "Room type" },
    },
    rate: {
        name: "rate",
        label: { ru: "Тариф", en: "Rate" },
    },
    name: {
        name: "name",
        label: { ru: "Название", en: "Name" },
    },
    guest: {
        name: "guest",
        label: { ru: "Гость", en: "Guest" },
    },
    firstName: {
        name: "first_name",
        label: { ru: "Имя", en: "First name" },
    },
    lastName: {
        name: "last_name",
        label: { ru: "Фамилия", en: "Last name" },
    },
    number: {
        name: "number",
        label: { ru: "Номер заявки", en: "Number" },
    },
    order_number: {
        name: "order_number",
        label: { ru: "Номер заказа", en: "Order number" },
    },
    promo_code: {
        name: "promo_code",
        label: { ru: "Промокод", en: "Promo code" },
    },
    login: {
        name: "login",
        label: { ru: "Логин", en: "Login" },
    },
    type: {
        name: "type",
        label: { ru: "Тип", en: "Type" },
    },
    email: {
        name: "email",
        label: { ru: "Email", en: "Email" },
    },
    hotels: {
        name: "hotels",
        label: { ru: "Отели", en: "Hotels" },
    },
    active: {
        name: "active",
        label: { ru: "Активность", en: "Active" },
    },
    hidden: {
        name: "hidden",
        label: { ru: "Скрытность", en: "hidden" },
    },
    inherited: {
        name: "inherited",
        label: { ru: "Наследование", en: "inherited" },
    },
    promo_name: {
        name: "promo_name",
        label: { ru: "Промокод", en: "Promo" },
    },
    order_source: {
        name: "order_source",
        label: { ru: "Источник заказа", en: "Order source" },
    },
    entity_id: {
        name: "entity_id",
        label: { ru: "Входящий ид", en: "Id" },
    },
    message_type: {
        name: "message_type",
        label: { ru: "Тип сущности", en: "message_type" },
    },
    id: {
        name: "id",
        label: { ru: "Ид", en: "Id" },
    },
    interface_name: {
        name: "interface_name",
        label: { ru: "Код интерфейса", en: "interface_name" },
    },
    status_pms: {
        name: "status_pms",
        label: { ru: "Статус PMS", en: "Status PMS" },
    },
    purchased_status: {
        name: "purchased_status",
        label: { ru: "Статус", en: "Status" },
    },
    reservation_number: {
        name: "reservation_number",
        label: { ru: "Номер заказа", en: "reservation number" },
    },
    category_services: {
        name: "category_services",
        label: { ru: "Категория услуги", en: "category service" },
    },
    reservation_id: {
        name: "reservation_id",
        label: { ru: "ИД заявки", en: "reservation id" },
    },
};

export const DEFAULT_GET_PARAMS = {
    page: "1",
    sortField: "id",
    sortOrder: DESC,
};

export const DEFAULT_GET_PARAMS_RATES_AND_SERVICES = {
    page: "1",
    sortField: "id",
    sortOrder: DESC,
};

export const rateChangeOperations = {
    add: { label: { en: "Add", ru: "Прибавить" }, value: "add" },
    subtract: { label: { en: "Subtract", ru: "Вычесть" }, value: "subtract" },
    multiply: { label: { en: "Multiply", ru: "Умножить" }, value: "multiply" },
    divide: { label: { en: "Divide", ru: "Разделить" }, value: "divide" },
    equally: { label: { en: "Equally", ru: "Равно" }, value: "equally" },
};

export const editRateByRuleFormType = {
    assign: "assign",
    calculate: "calculate",
    calculate_multiple: "calculate_multiple",
};

export const SEARCH_ERROR_MSG = {
    label: {
        ru: "Ошибка в полях: ",
        en: "Error in fields: ",
    },
};

export const STATE_DATE_FORMAT = "YYYY-MM-DD";
export const SHOW_DATE_FORMAT = "DD/MM/yyyy";

export const MATERIAL_UI_PROPS = {
    sizes: {
        small: "small",
        medium: "medium",
    },
    varinats: {
        contained: "contained",
        outlined: "outlined",
        inline: "inline",
    },
    colors: {
        default: "default",
        error: "error",
        secondary: "secondary",
        primary: "primary",
    },
};

export const REGEX_FOR_ALL_BLANKS = /\s/g;
export const REGEX_FOR_MULTIPLE_SPACES = /\s+/g;
export const MAX_DATA_AMNT_GAP = 10;

export const MAX_LINES_FOR_DATE = 7;

export const MAX_RATE_VALS_TO_SEND = 300;

export const VALUE_TYPES = {
    digit: { label: { ru: "Число", en: "Number" }, value: "digit" },
    percent: { label: { ru: "Процент", en: "Percent" }, value: "percent" },
};

export const INHERIT_VALUES = {
    1: { label: { ru: "Да", en: "Yes" }, value: 1 },
    0: { label: { ru: "Нет", en: "No" }, value: 0 },
};

export const FIELDS_TO_FILTER = {
    view: ["hotels", "password", "accommodation_types"],
    edit: ["hotels", "api_token", "accommodation_types"],
};

export const ALL_RATES = {
    name: "Все тарифы",
    date_end: "3000-01-01",
    date_start: "2000-01-01",
    active: 1,
    order: 1,
    own_quotas: 1,
    id: 99999999,
    code: "Все тарифы",
};
